import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { FormattedMessage } from 'react-intl'
import { compose } from 'recompose'

import { AwardUnitsOverview } from 'containers/sections/award-units'
import { AuthorisingContact, Coordinators } from 'containers/forms/organizations'
import { Form } from 'components/layout'
import { DetailLoader } from 'components/loaders'
import { FormButton, FloatingBar } from 'components/misc'
import { AddressBlock } from 'components/sections/common'
import { AwardUnitDetail } from 'components/sections/award-units'
import { getBillingAddressFormStatus } from 'helpers/uiPermissions'
import { Input } from 'components/fields'

import { apiOrganizations, apiCommon, apiDownloadFile, apiConfiguration } from 'helpers/decorators/api'
import { form, meta } from 'helpers/decorators'
import { CONFIGURATION_KEYS } from 'constants/enums'

const enhance = compose(
  meta({
    title: 'My Organisation - Detail',
    intlKey: 'pageTitle.my_organization_detail',
  }),
  apiOrganizations({
    myDetail: true,
    params: 'STAFF_COUNT',
  }),
  apiDownloadFile(),
  apiConfiguration({
      getValues: [
        CONFIGURATION_KEYS.isGOPEnabled.id
      ]
  }),
  apiCommon({
    regions: true,
  }),
  form({
    form: 'myOrganization',
    initialProps: 'organizations.detail',
  })
)

class MyOrganization extends Component {
  static propTypes = {
    pristine: PropTypes.bool.isRequired,
    invalid: PropTypes.bool.isRequired,
    submitSucceeded: PropTypes.bool.isRequired,
    submitFailed: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    change: PropTypes.func.isRequired,
    onDownloadFile: PropTypes.func.isRequired,
    values: PropTypes.object,
    files: PropTypes.object,
    organizations: PropTypes.object.isRequired,
    updateMyOrganization: PropTypes.func.isRequired,
    onChangeAuthorizingContact: PropTypes.func.isRequired,
    onRemoveCoordinator: PropTypes.func.isRequired,
    onMakeLeadCoordinator: PropTypes.func.isRequired,
    onChangeCoordinator: PropTypes.func.isRequired,
    common: PropTypes.object.isRequired,
    codeLists: PropTypes.object.isRequired,
    user: PropTypes.object
  }

  render() {
    const {
      pristine,
      invalid,
      submitSucceeded,
      submitFailed,
      change,
      values,
      files,
      common,
      codeLists,
      organizations,
      handleSubmit,
      updateMyOrganization,
      user,
    } = this.props

    const [isLicenseeFieldVisible, isAddressReadOnly] = getBillingAddressFormStatus(user, get(organizations, 'detail.hierarchyLevel.value'))

    return (
      <Form
        loading={organizations.loading}
        contentLoader={<DetailLoader withLogo />}
        onSubmit={handleSubmit(updateMyOrganization)}
        isOrganization
      >
        <div className="row">
          <div className="col-xs-6">
            <AwardUnitDetail
              organizationTypes={codeLists.organizationTypes.list}
              data={values}
              change={change}
              files={files}
              onDownloadFile={this.props.onDownloadFile}
            />
          </div>
          <div className="col-xs-6">
            <div className="row">
              <div className="col-xs-12">
                <AwardUnitsOverview displaySettings={false} data={get(organizations, 'detail')} />
              </div>
                  <div className="col-xs-12">
				  <AuthorisingContact
				    data={get(organizations, 'detail.authorizingContact')}
					organizationId={get(values, 'id')}
					onContactChange={this.props.onChangeAuthorizingContact}
				   />
				  </div>
              <div className="col-xs-12">
                <Coordinators
                  data={get(organizations, 'detail.coordinators')}
                  organizationId={get(values, 'id')}
                  onContactChange={this.props.onChangeCoordinator}
                  onRemoveCoordinator={this.props.onRemoveCoordinator}
                  onMakeLeadCoordinator={this.props.onMakeLeadCoordinator}
                  decoFilter="isAwardLeader"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-6">
            <AddressBlock
              title="Billing Address"
              intlKey="moduleTitle.billing_address"
              resetAward={false}
              formPrefix="invoiceAddress"
              change={change}
              regions={common.regions.list}
              readOnly={isAddressReadOnly}
              prependFields={
                isLicenseeFieldVisible && (
                  <Input
                    label="Licensee name"
                    intlKey="label.organisation_invoicing_name"
                    name="invoicingName"
                    readonly={isAddressReadOnly}
                  />
                )
              }
              isOrganizationAddress
            />
          </div>
          <div className="col-xs-6">
            <AddressBlock
              title="Shipping Address"
              intlKey="moduleTitle.shipping_address"
              formPrefix="address"
              copyFrom="invoiceAddress"
              withAction
              resetAward={false}
              change={change}
              data={values}
              regions={common.regions.list}
              isOrganizationAddress
            />
          </div>
        </div>
        <FloatingBar>
          <FormButton
            pristine={pristine}
            invalid={invalid}
            submitSucceeded={submitSucceeded}
            submitFailed={submitFailed}
          >
            <FormattedMessage id="button.save" defaultMessage="Save" />
          </FormButton>
        </FloatingBar>
      </Form>
    )
  }
}

export default enhance(MyOrganization)
